import { render } from "./WearablesDashboard.vue?vue&type=template&id=0c65dd78&scoped=true"
import script from "./WearablesDashboard.vue?vue&type=script&lang=js"
export * from "./WearablesDashboard.vue?vue&type=script&lang=js"

import "./WearablesDashboard.vue?vue&type=style&index=0&id=0c65dd78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c65dd78"]])

export default __exports__